import styled from 'styled-components';
import theme from '../../assets/styles/theme/theme';

export const ModalOverlay = styled.div``;

export const LongSteelMvpContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & span {
    display: block;
  }

  & strong {
    color: ${theme.colors.grayDark4};
    font-weight: 700;
  }
`;

export const LongSteelMvpImg = styled.img`
  width: 100%;
`;
